<template>
  <div class="case-show-container">
    <seg-carousel
      :item-top="false"
      height="500px"
      :modal-shadow="false"
      :imgs="[{'src': require('@/assets/img/case-show-page/banner-back.png')}]"
      indicator-position="none"
    >
      <template v-slot:modal-layer>
        <pull-down-notice-arrow style="left: calc(50% - 15px);" />
      </template>
    </seg-carousel>
    <seg-main
      width="1300px"
      style="margin-top: 0"
    >
      <template v-slot:title-text>
        <span style="color: #323232;">搜索结果</span>
      </template>
      <template v-slot:title-text-en>
        <span style="color: #6e6e6e;">Search</span>
      </template>
      <template v-slot:back-word>
        <span style="color:#f6f6f6;">RESULT</span>
      </template>
      <div>
        <h4>关于“{{ $route.query.keyword }}”的搜索结果（{{ page.result.total }}条）：</h4>
        <case-show-list-item
          v-for="item of result"
          :key="item.id"
          :img-src="item.coverPicKey"
        >
          <template v-slot:title>
            <div @click="$router.push({name: 'SearchDetail', params: {articleId: item.id}})">
              {{ item.title }}
            </div>
          </template>
          <template v-slot:content>
            {{ item|introduceOrContent|removeTagAndCutTop|transHtmlEntity }}...
          </template>
        </case-show-list-item>
        <el-pagination
          background
          :current-page.sync="page.result.curPage"
          layout="prev, pager, next"
          :total="page.result.total"
          @current-change="getResult()"
        />
      </div>
    </seg-main>
  </div>
</template>

<script>
import SegCarousel from '@/components/indexTopCarousel/segCarousel';
import PullDownNoticeArrow from '@/components/pullDownNoticeArrow/pullDownNoticeArrow';
import SegMain from '@/components/segPart/segMain';
import CaseShowListItem from '@/components/caseShowList/caseShowListItem';
import {getArticle} from '@/api';
import dayjs from 'dayjs';

export default {
  name: 'Search',
  components: {
    CaseShowListItem, SegMain, PullDownNoticeArrow, SegCarousel,
  },
  data() {
    return {
      page: {
        result: {
          total: 0,
          curPage: 1
        }
      },
      result: []
    };
  },
  mounted() {
    this.getResult()
  },
  methods: {
    getResult() {
      getArticle({
        categories_id: '[1,2,5,9,10,11,12,13,14,15,16,17,18,19,20]',
        page: this.page.result.curPage,
        title: this.$route.query.keyword || ''
      }).then(res => {
        if(res.data.success) {
          this.result = res.data.data.map(item => {
            return {
              ...JSON.parse(item.content),
              id: item.id,
              publishDate: dayjs(item.confirmed_at).format('YYYY-MM-DD')
            }
          })
        }
        this.page.result.total = res.data.total
      })
    }
  }
};
</script>

<style scoped>

</style>
